import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { BountyCardComponent } from './components/bounties/bounty-card/bounty-card.component';
import { AppRoutingModule } from './app-routing.module';
import { BountiesListComponent } from './components/bounties/bounties-list/bounties-list.component';
import { CreateBountyComponent } from './components/create-bounty/create-bounty.component';
import { ApiService } from './services/api.service';
import { BountyService } from './services/bounty.service';
import { HttpClientModule } from '@angular/common/http';
import { SuiModule } from 'ng2-semantic-ui';
import { ViewBountyComponent } from './components/bounties/view-bounty/view-bounty.component';
import { CommentsSectionComponent } from './components/comments/comments-section/comments-section.component';
import { ClaimBountyFormComponent } from './components/claim-bounty-form/claim-bounty-form.component';
import { ViewClaimComponent } from './components/view-claim/view-claim.component';
import { UserProfileComponent } from './components/my-bounties-list/user-profile.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { SupportComponent } from './components/support/support.component';
import { UserLabelComponent } from './components/user-label/user-label.component';
import { BountiesTableComponent } from './components/bounties-table/bounties-table.component';
import { CommentPipe } from './pipes/comment.pipe';
import { StatsComponent } from './components/stats/stats.component';
import { BeatmapGoalsFieldsComponent } from './components/create-bounty/form-sections/beatmap-goals-fields.component';
import { GeneralFieldsComponent } from './components/create-bounty/form-sections/general-fields.component';
import { EditBountyComponent } from './components/edit-bounty/edit-bounty.component';
import { BountiesFiltersComponent } from './components/bounties/bounties-filters/bounties-filters.component';
import { HeaderComponent } from './header/header.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { CommentsComponent } from './components/comments/comments.component';
import { PageLoaderComponent } from './components/page-loader/page-loader.component';
import { WindowService } from './services/window.service';
import { PaymentFormComponent } from './components/payment-form/payment-form.component';
import { PaymentCompleteComponent } from './components/payment-complete/payment-complete.component';
import { DisabledPlaceholderComponent } from './components/create-bounty/disabled-placeholder/disabled-placeholder.component';

@NgModule({
  declarations: [
    AppComponent,
    BountyCardComponent,
    BountiesListComponent,
    CreateBountyComponent,
    ViewBountyComponent,
    CommentsSectionComponent,
    ClaimBountyFormComponent,
    ViewClaimComponent,
    UserProfileComponent,
    ConfirmModalComponent,
    SupportComponent,
    UserLabelComponent,
    BountiesTableComponent,
    CommentPipe,
    StatsComponent,
    BeatmapGoalsFieldsComponent,
    GeneralFieldsComponent,
    EditBountyComponent,
    BountiesFiltersComponent,
    HeaderComponent,
    NotificationsComponent,
    CommentsComponent,
    PageLoaderComponent,
    PaymentFormComponent,
    PaymentCompleteComponent,
    DisabledPlaceholderComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SuiModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [WindowService],
  bootstrap: [AppComponent],
  entryComponents: [ConfirmModalComponent],
})
export class AppModule {}
